import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { BulkEmailInput } from '@/models/email';

export const sendBulkEmailByCallerIds = async ({ from, subject, body, purpose, list, delayBetweenSendingEachEmail }: BulkEmailInput) => {
  const response = await mutationExecute({
    variables: {
      from,
      subject,
      body,
      purpose,
      list,
      delayBetweenSendingEachEmail,
    },
    mutation: graphql(`
      mutation SendBulkEmailByCallerIds(
        $from: String!
        $subject: String!
        $body: String!
        $purpose: String!
        $list: [String!]!
        $delayBetweenSendingEachEmail: Float!
      ) {
        sendBulkEmailByCallerIds(
          from: $from
          subject: $subject
          body: $body
          purpose: $purpose
          list: $list
          delayBetweenSendingEachEmail: $delayBetweenSendingEachEmail
        ) {
          success
          receiverCount
          warnings {
            nonCallerEmailAddresses
            callerIdsWithoutEmailAddress
          }
        }
      }
    `),
  });

  return response.data?.sendBulkEmailByCallerIds;
};
